import { serialize } from "../../../helpers/helpers";
import { apiRequest, getSluiceUrl } from "../../../apiHelper/apiRequest";

const nc_list = async params => {
  return apiRequest(
    "/news/types/list?" + serialize(params),
    {
      method: "GET"
    },
    'ptp_core'
  );
}

const nc_add = async params => {
  let add_response = await apiRequest(
    "/news/types/add",
    {
      'method': "POST",
      'headers': {
        'content-type': 'application/json'
      },
      'body': JSON.stringify(params)
    },
    'ptp_core'
  );
  
  if (typeof (add_response.id) !== 'undefined' && add_response.id)
    return add_response.id;
  else
    return 0;
}

const nc_update = async params => {
  let add_response = await apiRequest(
    "/news/types/update",
    {
      'method': "PUT",
      'headers': {
        'content-type': 'application/json'
      },
      'body': JSON.stringify(params)
    },
    'ptp_core'
  );

  if (typeof (add_response.id) !== 'undefined' && add_response.id)
    return add_response.id;
  else
    return 0;
}

const nc_remove = async (id = 0) => {
  let remove_response = await apiRequest(
    "/news/types/delete/" + id,
    {
      method: "DELETE"
    },
    'ptp_core'
  );

  if (typeof (remove_response.id) !== 'undefined' && remove_response.id)
    return remove_response.id;
  else
    return 0;
}

const nc_getImageUrl = (image_path = '') => {
  if (String(image_path).trim() === '' || image_path.indexOf('http') === 0)
    return image_path;
  return getSluiceUrl('ptp_core') + "/news/files/" + image_path;
}

const newsCategories = {
  nc_list,
  nc_add,
  nc_update,
  nc_remove,
  nc_getImageUrl,
};
export default newsCategories;